module.exports = __webpack_public_path__ + "img/oddvega-logo-new-curve-hover.72a93452.png";